import { render, staticRenderFns } from "./form-immutable.vue?vue&type=template&id=5d5113c8&"
import script from "./form-immutable.vue?vue&type=script&lang=js&"
export * from "./form-immutable.vue?vue&type=script&lang=js&"
import style0 from "./form-immutable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports